import React from 'react';

const Features = () => {
    return (
        <main id="features">
            <p><strong><em>Antoine Cole Consulting</em></strong>  is a full accommodation bookkeeping and accounting firm, that brings a unique approach to the industry. We offer customized financial solutions as well as onsite and remote service to meet the all the needs of our clients. We always aim to create a long lasting relationship that is built on trust and confidentiality, enabling us to communicate and collaborate as we grow your business.</p>

            <p><strong><em>Antoine Cole Consulting</em></strong> is an affordable, full-service solution that reduces overhead, eliminates hassles and helps build your business.</p>

            <h2><span className="primary-text">Our</span> Mission</h2>
            
            <p><strong><em>Antoine Cole Consulting</em></strong> provides clients with professional and effective methods of bookkeeping and accounting for your small business, developments or forensic auditing needs. Our experienced staff will customize a financial solution for your company that will run seamlessly in the background while you run the day-to-day operations. We offer both onsite and remote bookkeeping and accounting services as well as payroll processing with quarterly and annual filings.
            </p>
        </main>
    );
}

export default Features;